import React from 'react';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';
import { Text } from 'wix-ui-tpa/Text';
import ShowMoreText from 'react-show-more-text';
import { TextButton, TEXT_BUTTON_PRIORITY } from 'wix-ui-tpa/TextButton';
import settingsParams from '../../../settingsParams';
import s from './ProductDescription.scss';
import { useControllerProps } from '../../ControllerContext';
import { Property } from 'csstype/index';

const ProductDescription = () => {
  const settings = useSettings();
  const { product } = useControllerProps().giftCardStore;

  const description = product?.description;

  const moreButton = (
    <>
      <div></div>
      <TextButton
        data-hook="rise-gift-card-product-description-read-more-button"
        priority={TEXT_BUTTON_PRIORITY.link}
      >
        {settings.get(settingsParams.descriptionReadMoreButton)}
      </TextButton>
    </>
  );

  const lessButton = (
    <>
      <div></div>
      <TextButton
        data-hook="rise-gift-card-product-description-less-button"
        priority={TEXT_BUTTON_PRIORITY.link}
      >
        {settings.get(settingsParams.descriptionReadLessButton)}
      </TextButton>
    </>
  );

  return (
    <div
      className={s.description}
      style={{
        textAlign: settings.get(
          settingsParams.descriptionAlignment,
        ) as Property.TextAlign,
      }}
    >
      <Text>
        <ShowMoreText
          lines={settings.get(settingsParams.descriptionLimitRows)}
          more={moreButton}
          less={lessButton}
          expanded={false}
          keepNewLines={true}
        >
          {description}
        </ShowMoreText>
      </Text>
    </div>
  );
};

export default ProductDescription;
